export const routes =  (prefix = `morgue`) => [
    {
        path: `/${prefix}/admission-report`,
        name: `${prefix}.admission-report.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.admission-report.index`,
                PageDescription: "Morgue: Admission Report",
            },
        },
    },
    {
        path: `/${prefix}/admission-note`,
        name: `${prefix}.admission-note.index`,
        component: () => import('./prints/AdmissionNote.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.admission-report.index`,
                PageDescription: "Morgue: Admission Report",
            },
        },
    },
];
